<template>
	<sa-page-layout ref="cmpSaPageLayout" :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="toolbar">
			<b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickCambiaStatoAttivita"><i class="fas fa-exchange-alt"></i>Cambia Stato </b-button>
			<b-button class="my-2 my-sm-0" variant="outline-success btn-toolbar sa-margin-left float-sm-left" :disabled="btnNuovoTaskDisabled" :hidden="btnNuovoTaskHidden" @click="onClickNuovoTask">
				<b-icon icon="plus" aria-hidden="true"></b-icon>
				Nuovo Task
			</b-button>
			<b-button class="my-2 my-sm-0" variant="outline-success btn-toolbar sa-margin-left float-sm-left" :hidden="btnAssociaProdottoHidden" @click="onClickAssociaProdotto"> <i class="fab fa-accusoft" aria-hidden="true"></i> Associa Prodotto </b-button>
			<b-button class="my-2 my-sm-0" variant="outline-success btn-toolbar sa-margin-left float-sm-left" :hidden="btnAssociaProgettoHidden" @click="onClickAssociaProgetto"> <i class="fas fa-project-diagram" aria-hidden="true"></i>Associa Progetto </b-button>
		</template>
		<template slot="table-header">
			<gestione-attivita-attivita-view-component ref="cmpGestioneAttivitaAttivitaViewComponent" @updateJsonData="onUpdateJsonDataAttivita"></gestione-attivita-attivita-view-component>
		</template>
		<template slot="table-body">
			<b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
				<b-tab active>
					<template #title> <i class="fas fa-tasks"></i><span style="padding-left: 10px">Tasks</span></template>
					<gestione-attivita-task-list-component ref="cmpGestioneAttivitaTaskListComponent" @afterLoadData="onAfterLoadDataGestioneAttivitaTaskListComponent"></gestione-attivita-task-list-component>
				</b-tab>

				<b-tab>
					<template #title> <i class="fab fa-accusoft"></i><span style="padding-left: 10px">Prodotti</span> </template>
					<gestione-attivita-progetti-list-component ref="cmpGestioneAttivitaProdottiListComponent" @afterRimuoviAssociazione="onAfterRimuoviAssociazioneProdotti"></gestione-attivita-progetti-list-component>
				</b-tab>
				<b-tab>
					<template #title> <i class="fas fa-project-diagram"></i><span style="padding-left: 10px">Progetti</span> </template>
					<gestione-attivita-progetti-list-component ref="cmpGestioneAttivitaProgettiListComponent" @afterRimuoviAssociazione="onAfterRimuoviAssociazioneProgetti"></gestione-attivita-progetti-list-component>
				</b-tab>
				<b-modal title="Nuova Task" ref="mdlEditTask" id="mdlEditTask" size="xl" @shown="onShownNuovoTask" @ok="onOkEditTask">
					<gestione-attivita-task-edit-component ref="cmpGestioneAttivitaTaskEditComponent"></gestione-attivita-task-edit-component>
				</b-modal>
				<gestione-attivita-attivita-list-select-modal ref="cmpGestioneAttivitaAttivitaListSelectModal" @associzioneAvvenuta="onAssocizioneAvvenutaProdotto"></gestione-attivita-attivita-list-select-modal>
				<modal-error ref="cmpModalError"></modal-error>
				<state-change-modal-component ref="cmpStateChangeModalComponent" @cambioStatoSuccess="onCambioStatoSuccess"></state-change-modal-component>
			</b-tabs>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaAttivitaViewComponent from "../components/GestioneAttivitaAttivitaViewComponent.vue";
import GestioneAttivitaTaskListComponent from "../components/GestioneAttivitaTasksListComponent.vue";
import GestioneAttivitaTaskEditComponent from "../components/GestioneAttivitaTasksEditComponent.vue";
import GestioneAttivitaProgettiListComponent from "../components/GestioneAttivitaProgettiListComponent.vue";
import GestioneAttivitaAttivitaListSelectModal from "../components/GestioneAttivitaAttivitaListSelectModal.vue";
import StateChangeModalComponent from "../../utility/components/StateChangeModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
	mixins: [UtilityMixin],
	components: { SaPageLayout, GestioneAttivitaAttivitaViewComponent, GestioneAttivitaTaskListComponent, GestioneAttivitaTaskEditComponent, GestioneAttivitaProgettiListComponent, GestioneAttivitaAttivitaListSelectModal, ModalError, StateChangeModalComponent },
	data() {
		return {
			idAttivita: null,
			activeTabIndex: 0,
			btnSaveVisible: true,
			showModalLoading: false,
			linkback: "/gestioneattivita/attivita",
			pathResource: "/gestioneattivitaattivita",
			pathResourceTasks: "/gestioneattivitatasks",
			pathResourceProdottiAttivita: "/gestioneattivitaprogetti/prodotti",
			pathResourceProgettiAttivita: "/gestioneattivitaprogetti/progetti",
			pathResourceStatiAttivita: "/gestioneattivitastati",
			pathResourceAggiornaStato: "/gestioneattivitaattivitastatistorico",
			jsonData: null,
			btnNuovoTaskHidden: false,
			btnAssociaProdottoHidden: true,
			btnAssociaProgettoHidden: true,
			btnNuovoTaskDisabled: true,
		};
	},
	mounted() {
		this.idAttivita = this.$route.params.id;
		this.$refs.cmpGestioneAttivitaTaskListComponent.init({ idAttivita: this.idAttivita });
	},
	methods: {
		onUpdateJsonDataAttivita(jsonData) {
			this.jsonData = jsonData;
			this.btnNuovoTaskDisabled = true;
			if (this.jsonData.statoAttuale === "IN LAVORAZIONE") {
				this.btnNuovoTaskDisabled = false;
			}
		},
		onInputTabs(index) {
			switch (index) {
				case 0:
					this.btnNuovoTaskHidden = false;
					this.btnAssociaProdottoHidden = true;
					this.btnAssociaProgettoHidden = true;
					break;
				case 1:
					this.btnNuovoTaskHidden = true;
					this.btnAssociaProdottoHidden = false;
					this.btnAssociaProgettoHidden = true;
					this.$refs.cmpGestioneAttivitaProdottiListComponent.loadFromAttivita(this.pathResourceProdottiAttivita + "/" + this.idAttivita, {});
					break;
				case 2:
					this.btnNuovoTaskHidden = true;
					this.btnAssociaProdottoHidden = true;
					this.btnAssociaProgettoHidden = false;
					this.$refs.cmpGestioneAttivitaProgettiListComponent.loadFromAttivita(this.pathResourceProgettiAttivita + "/" + this.idAttivita, {});
					break;
			}
		},
		onClickNuovoTask() {
			let me = this;
			me.$refs.mdlEditTask.show();
		},
		onShownNuovoTask() {
			let me = this;
			me.$refs.cmpGestioneAttivitaTaskEditComponent.init({ idAttivita: me.jsonData.id, idTask: "-1" });
		},
		onOkEditTask(bvModalEvt) {
			let me = this;
			bvModalEvt.preventDefault();
			let jsonDataTask = me.$refs.cmpGestioneAttivitaTaskEditComponent.getJsonDataTask();
			UtilityMixin.methods.saveResource(me.pathResourceTasks, jsonDataTask, me.saveTaskSuccess, me.saveTaskError);
		},
		saveTaskSuccess() {
			let me = this;
			me.$refs.mdlEditTask.hide();
			this.$refs.cmpGestioneAttivitaTaskListComponent.init({ idAttivita: this.idAttivita });
		},
		saveTaskError(error) {
			let me = this;
			me.$refs.cmpModalError.show(error.response.data.messaggio);
		},
		onClickAssociaProdotto() {
			let me = this;
			me.$refs.cmpGestioneAttivitaAttivitaListSelectModal.show("Prodotti", "PRODOTTO", me.idAttivita);
		},
		onClickAssociaProgetto() {
			let me = this;
			me.$refs.cmpGestioneAttivitaAttivitaListSelectModal.show("Progetti", "PROGETTO", me.idAttivita);
		},
		onAfterRimuoviAssociazioneProdotto() {
			this.$refs.cmpGestioneAttivitaProgettiListComponent.loadFromAttivita(this.pathResourceProdottiAttivita + "/" + this.idAttivita, {});
		},
		onAfterRimuoviAssociazioneProgetti() {
			this.$refs.cmpGestioneAttivitaProgettiListComponent.loadFromAttivita(this.pathResourceProgettiAttivita + "/" + this.idAttivita, {});
		},
		onAssocizioneAvvenutaProdotto() {
			this.$refs.cmpGestioneAttivitaProdottiListComponent.loadFromAttivita(this.pathResourceProdottiAttivita + "/" + this.idAttivita, {});
			this.$refs.cmpGestioneAttivitaProgettiListComponent.loadFromAttivita(this.pathResourceProgettiAttivita + "/" + this.idAttivita, {});
		},
		onAfterRimuoviAssociazioneProdotti() {
			this.$refs.cmpGestioneAttivitaProgettiListComponent.loadFromAttivita(this.pathResourceProgettiAttivita + "/" + this.idAttivita, {});
		},
		onClickCambiaStatoAttivita() {
			this.$refs.cmpStateChangeModalComponent.show({ idAttivita: this.idAttivita }, this.pathResourceStatiAttivita, this.pathResourceAggiornaStato);
		},
		onCambioStatoSuccess() {
			this.$refs.cmpGestioneAttivitaAttivitaViewComponent.loadData();
		},
		onAfterLoadDataGestioneAttivitaTaskListComponent(items) {
			this.$refs.cmpGestioneAttivitaAttivitaViewComponent.setProgress(items);
		},
	},
};
</script>

<style></style>
